export default __webpack_public_path__ + "static/media/gournay12.90e8f1ec.jpg";